<div class="wyc" [class.wyc--compact]="compact" role="region" [attr.aria-label]="copy.controlTitle">
  <strong class="wyc-title">{{ copy.controlTitle }}</strong>
  <p class="wyc-support">{{ copy.controlSupport }}</p>
  <ul class="wyc-list">
    <li *ngFor="let item of copy.controlItems">
      <strong>{{ item.title }}</strong>
      <span>{{ item.detail }}</span>
    </li>
  </ul>
</div>
